import { Controller } from "@hotwired/stimulus"

// Adds .play on the next frame so the hero's clip-path / opacity / translate
// transitions kick in. Under reduced motion, CSS already resolves .anim to its
// final state, so the class is harmless either way.
export default class extends Controller {
  connect() {
    requestAnimationFrame(() => this.element.classList.add("play"))
  }
}
